const SHOULD_REGISTER =
  process.env.NODE_ENV === 'production' &&
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator;

export function registerPwa() {
  if (!SHOULD_REGISTER) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', {
        scope: '/',
        updateViaCache: 'none',
      })
      .catch(error => {
        console.error('Failed to register service worker', error);
      });
  });
}
